let n = [];
const c = { documentElement: {}, body: {} }, i = Object.freeze({
  // html
  documentElement: {
    "scrollbar-gutter": "stable"
  },
  body: {
    overflow: "hidden",
    position: "relative",
    height: "100%"
  }
}), r = (t) => {
  t.touches.length > 1 || t.preventDefault?.();
}, h = (t) => ([e, s]) => {
  c[t][e] = document[t].style[e], document[t].style[e] = s;
}, a = () => Object.entries(i).forEach(([t, e]) => {
  Object.entries(e).forEach(h(t));
}), d = (t) => ([e, s]) => {
  document[t].style[e] = c[t][e];
}, f = () => Object.entries(c).forEach(([t, e]) => {
  Object.entries(e).forEach(d(t));
}), m = (t) => t.scrollHeight - Math.abs(t.scrollTop) === t.clientHeight;
function y(t) {
  let e = -1;
  const s = (o) => {
    if (o.targetTouches.length !== 1)
      return;
    const l = o.targetTouches[0].clientY - e;
    return t.scrollTop === 0 && l > 0 || m(t) && l < 0 ? r(o) : (o.stopPropagation(), !0);
  };
  t.ontouchstart = (o) => {
    o.targetTouches.length === 1 && (e = o.targetTouches[0].clientY);
  }, t.ontouchmove = s;
}
function p(t) {
  t.ontouchstart = null, t.ontouchmove = null;
}
const u = (t) => () => document[t ? "addEventListener" : "removeEventListener"]("touchmove", r, { passive: !1 }), b = u(!0), g = u();
function E(t) {
  if (!t)
    throw Error("Could not run setup, an element must be provided");
  n.some((e) => e === t) || (n.length || (a(), b()), y(t), n.push(t));
}
function T() {
  n.forEach(p), g(), f(), n = [];
}
export {
  f as resetStyles,
  a as setStyles,
  E as setup,
  i as styleTargets,
  T as teardown
};
